import * as React from "react";

import { cn } from "@/lib/utils";

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          "border-gray-light/40 text-body-2 flex h-32 w-full rounded-lg border bg-white px-4 py-3 text-secondary-800 subpixel-antialiased outline-none file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-secondary-400 focus:border-secondary-400 focus:outline-secondary-400",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Textarea.displayName = "Textarea";

export { Textarea };
